import { Component} from '@angular/core';

@Component({
  selector: 'app-loader-mini',
  templateUrl: './loader-mini.component.html'
})
export class LoaderMiniComponent {
  
}
